import React, {memo} from 'react';
import {
    Avatar,
    Tooltip,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import TableIcons from '../../utils/TableIcons';
import {navigate} from '@reach/router';

import LaunchIcon from '@material-ui/icons/Launch';
import RefreshIcon from '@material-ui/icons/Refresh';
import GavelIcon from '@material-ui/icons/Gavel';
import SendIcon from '@material-ui/icons/Send';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import setActiveIcon from "../../utils/setActiveIcon";
const PingTreesTable = memo(({useIconClasses, refetch, data}) => {
    /**
     *
     * @param {string} type - Campaign Type
     */
    const getIconType = (type) => {
        switch (type) {
            case 'PRICE_REJECT':
            case 'STATIC':
                return (
                    <Tooltip title={type}>
                        <Avatar
                            className={type === 'PRICE_REJECT' ? (useIconClasses.primary) : (useIconClasses.secondary)}>
                            <SendIcon/>
                        </Avatar>
                    </Tooltip>
                );
            case 'AUCTION':
            case 'VERIFIED_AUCTION':
                return (
                    <Tooltip title={type}>
                        <Avatar className={type === 'AUCTION' ? (useIconClasses.primary) : (useIconClasses.secondary)}>
                            <GavelIcon/>
                        </Avatar>
                    </Tooltip>
                );
            default:
                return (
                    <Tooltip title={type}>
                        <Avatar className={useIconClasses.primary}>
                            <GroupWorkIcon/>
                        </Avatar>
                    </Tooltip>
                );
        }
    };

    return (
        <MaterialTable
            title={""}
            options={{
                pageSize: 20,
                pageSizeOptions: [20, 50, 100]
            }}
            icons={TableIcons}
            columns={[
                {title: "Type", field: "type"},
                {title: "Id", field: "id"},
                {title: 'Active', field: "active"},
                {title: "Name", field: "name"},
                {title: "Price", field: "price", type: "numeric"},
                {title: "Servicer", field: "servicer"},
                {title: "Portfolio", field: "portfolio"},
            ]}
            data={data.map(campaign => ({
                type: getIconType(campaign.type),
                id: campaign.id,
                active: setActiveIcon(campaign.active),
                name: campaign.name || 'N/A',
                price: campaign.pricePoint,
                servicer: campaign.servicer.name || 'N/A',
                portfolio: campaign.portfolio.name || 'N/A'
            }))}
            actions={[
                {
                    icon: () => <RefreshIcon/>,
                    tooltip: 'Refetch Data',
                    isFreeAction: true,
                    onClick: (event) => refetch()
                },
                {
                    icon: () => <LaunchIcon/>,
                    tooltip: 'View Campaign',
                    onClick: (event, rowData) => navigate(`/info/campaigns/${rowData.id}`)
                },
            ]}
        />
    )
});

export default PingTreesTable;
